'use strict';

/**
* Disables specific product card and its quantity selector
* @param {jQuery} $quantitySelector - jQuery quantity selector element
*/
function disableProductCard($quantitySelector) {
    var $productCard = $quantitySelector.closest('.product-info');
    $productCard.addClass('error-state');
}

/**
* Disables checkout by adding error states and showing restrictions
* Updates UI elements to reflect disabled checkout state
* @param {Object} items - Object that contains the items that dont have Stock
*/
function disableCheckoutBegin(items) {
    var $availabilityMessagesContainerSummary = $('.delivery-restrictions');
    var $availabilityMessagesCheckoutContainer = $availabilityMessagesContainerSummary.find('.availability-message');
    var $deliveryDisclaimer = $availabilityMessagesContainerSummary.find('.cart_summary_disclaimer-container');

    if ($deliveryDisclaimer.length > 0) {
        $('.checkout-btn').addClass('disabled');
    }

    items.forEach(function(item) {
        var $productCard = $('.card.product-info.uuid-' + item.uuid);
        if ($productCard.length) {
            var $availabilityMessages = $productCard.find('.availability-message, .availability-message-mobile');
            var $increaseQuantityButton = $productCard.find('.quantity-increase');
            var $decreaseQuantityButton = $productCard.find('.quantity-decrease');

            if (item.availableQty < item.requestedQty) {
                $increaseQuantityButton.prop('disabled', true);
            }

            if (item.availableQty === 0) {
                $increaseQuantityButton.prop('disabled', true);
                $decreaseQuantityButton.prop('disabled', true);
            }

            if ($availabilityMessages.length) {
                $availabilityMessages.css('display', 'flex');
            }
        }
    });
    $availabilityMessagesCheckoutContainer.css('display', 'flex');
    $availabilityMessagesContainerSummary.removeClass('d-none');
    $('.checkout-btn').addClass('disabled');
}

/**
 * Enables checkout by removing error states and hiding restrictions.
 * Updates UI elements to reflect enabled checkout state.
 * @returns {boolean} Returns false if there are availability messages in checkout products, otherwise undefined
 */
function enableCheckoutBegin() {
    if($('.checkout-product-info .availability-message').length) {
        return false
    }
    var $availabilityMessages = $('.availability-message, .availability-message-mobile');
    var $availabilityMessagesContainerSummary = $('.delivery-restrictions');
    var $deliveryDisclaimer = $availabilityMessagesContainerSummary.find('.cart_summary_disclaimer-container');

    $availabilityMessages.removeClass('d-flex');
    $availabilityMessages.hide();

    $('.card.product-info').removeClass('error-state');
    if ($deliveryDisclaimer.length === 0 || $deliveryDisclaimer.children().length === 0) {
        $availabilityMessagesContainerSummary.removeClass('d-block');
        $availabilityMessagesContainerSummary.addClass('d-none');
        var isShippingBlocked = $('.checkout-btn').data('shipping-blocked') === true;
        if (!isShippingBlocked) {
            $('.checkout-btn').removeClass('disabled');
        }
    } else {
        $('.checkout-btn').addClass('disabled');
    }
    return true;
}

/**
 * Validates inventory for all items in cart
 * @param {string} validateInventoryUrl - URL to validate inventory
 * @returns {Promise} Promise that resolves with validation result
 */
function validateCartInventory(validateInventoryUrl) {
    return new Promise((resolve) => {
        if (validateInventoryUrl) {
            $.ajax({
                url: validateInventoryUrl,
                method: 'GET',
                success: function (data) {
                    if (data.error) {
                        disableCheckoutBegin(data.items)
                        // Clear any previous error states
                        $('.card.product-info').removeClass('error-state');
                        data.items.forEach(function(item) {
                            // Direct selector for the product card div using UUID
                            var $productCard = $('.card.product-info.uuid-' + item.uuid);
                            if ($productCard.length) {
                                var $quantitySelect = $productCard.find('.quantity-select');
                                if ($quantitySelect.length) {
                                    $productCard.addClass('error-state');
                                }
                            }
                        });

                        return;
                    }
                    enableCheckoutBegin()
                    resolve();
                },
                error: function () {
                    $('.checkout-btn').addClass('disabled');
                }
            });
        }
        else {
            $('.checkout-btn').addClass('disabled');
        }
    });
}

/**
 * Initialize checkout button validation
 */
function initCheckoutValidation() {
    var validateInventoryUrl = $('.validate-inventory-anchor').data('validate-inventory-url');
    var hasAddress = $('.checkout-btn').data('has-address');
    if(!hasAddress){
        $('.checkout-btn').addClass('disabled');
        // Prevent checkout enabling if quantity exceeds max, complement to reassertQuantityLimitBlock
        return Promise.resolve();
    }
    if(validateInventoryUrl){
        var validationPromise = validateCartInventory(validateInventoryUrl);
        $('.checkout-btn').on('click', function(e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) {
                return false;
            }
    
            var $link = $(this);
            var href = $link.attr('href');
    
            validateCartInventory(validateInventoryUrl).then(function() {
                if (!$link.hasClass('disabled')) {
                    window.location.href = href;
                }
            });
        });
        // Prevent checkout enabling if quantity exceeds max, complement to reassertQuantityLimitBlock
        return validationPromise;
    }else{
        // eslint-disable-next-line no-console
        console.error('validateInventoryUrl is not defined');
        // Prevent checkout enabling if quantity exceeds max, complement to reassertQuantityLimitBlock
        return Promise.resolve();
    }

}

/**
 * Validates the availability statuses of the basket in the remove pli response data.
 *
 * @param {Object} basket - The basket object containing updated basket info.
 */
function validateAvailabilityStatuses(basket) {
    var showOnlyDeliveryDisclaimer = basket.hasOnlyDeliveryFlag && basket.isLockerSelected;
    var showNotAvailableMessages = basket.anyProductIsNotAvailable || basket.hasActiveAlcoholRestriction || showOnlyDeliveryDisclaimer;

    if (!showOnlyDeliveryDisclaimer) {
        $('.only-delivery').remove();
    }

    if (!showNotAvailableMessages) {
        $('.delivery-restrictions').empty();
    }
}

module.exports = {
    validateCartInventory: validateCartInventory,
    initCheckoutValidation: initCheckoutValidation,
    disableCheckoutBegin: disableCheckoutBegin,
    enableCheckoutBegin: enableCheckoutBegin,
    disableProductCard: disableProductCard,
    validateAvailabilityStatuses: validateAvailabilityStatuses
};
